import * as React from 'react';
import {withStyles, WithStyles, StyleRules} from '@material-ui/core/styles';
import {Theme} from '@material-ui/core/styles';
import DefinitionSection from '../../form/definition-section';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import {IconButton, Menu, MenuItem} from '@material-ui/core';

const styles = (theme: Theme): StyleRules => {
  let selectionColor = 'orange';
  if (
    theme.overrides &&
    theme.overrides.MuiButton &&
    theme.overrides.MuiButton.raisedPrimary &&
    theme.overrides.MuiButton.raisedPrimary.backgroundColor
  ) {
    selectionColor = theme.overrides.MuiButton.raisedPrimary.backgroundColor;
  }

  return {
    container: {
      width: '100%',
      display: 'flex'
    },
    row: {
      width: '100%'
    },
    clickableRow: {
      width: '100%',
      cursor: 'pointer'
    },
    clickableMenu: {
      cursor: 'pointer',
      marginRight: 15,
      minWidth: 48,
      minHeight: 48
    },
    selectorArea: {
      width: 15,
      position: 'relative'
    },
    selectedRow: {
      border: '1px solid orange' //TODO:  Make this match the primary button color or another color from the theme, so that it is easily configurable.
    },
    unselectedRow: {
      border: '0px'
    },
    selector: {
      color: selectionColor,
      position: 'absolute',
      left: '0px',
      top: '0px'
    },
    selectorWithError: {
      color: 'red',
      position: 'absolute',
      left: '0px',
      top: '0px'
    }
  };
};

interface Props extends React.HTMLProps<HTMLDivElement> {
  itemData: any;
  resultItemDef: any;
  onRowClick?: Function;
  actionsForItemRow?: Function;
  reserveRowActionSpace: boolean;
  customRenderers?: any;
  customMessages?: any;
  className?: string;
  policyMessages?: Array<any>;
  gridSpacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 
  // the below are used for selection
  onSelectionChange?: Function;
  // passed from Query List to Definition section to replace the section title
  resultsTitleOverride?: string
  selected: boolean;
  index: number;
  criteria: any;
}

const ITEM_HEIGHT = 48;

// We will kepp internal state to give more customMessages to the consumers, but we will always defer to the data coming from the props.
type State = {
  anchorEl?: any;
  selected: boolean;
};

class QueryItemView extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      selected: false
    };
  }

  handleMenuClick = (event) => {
    this.setState({anchorEl: event.currentTarget});
  };

  handleMenuClose = () => {
    this.setState({anchorEl: null});
  };

  handleRowClick = () => {
    if (this.props.onRowClick) {
      this.props.onRowClick(this.props.itemData);
    }
  };

  handleActionClick = (action: any) => () => {
    this.handleMenuClose();
    if (action.onClick) {
      action.onClick(this.props.itemData);
    }
  };

  handleRowSelection = () => {
    //report up the selection.  The query lit will pass the seelction back in props.
    if (this.props.onSelectionChange) {
      this.props.onSelectionChange(this.props.itemData, !this.props.selected);
    }
  };

  render() {
    const {classes}: {classes: any} = this.props;
    const {
      actionsForItemRow,
      reserveRowActionSpace,
      customRenderers,
      customMessages,
      itemData,
      resultItemDef,
      policyMessages,
      gridSpacing,
      onSelectionChange,
      resultsTitleOverride,
      index,
      criteria
    } = this.props;


    const {anchorEl} = this.state;
    const open = Boolean(anchorEl);

    var actionArea;


    if (actionsForItemRow) {
      const actions = actionsForItemRow(itemData, criteria);
      if (actions && actions.length > 0) {
        actionArea = (
          <div
            className={classes.clickableMenu + ' ' + 'query-item-view-actions'}>
            <IconButton
              aria-label="More"
              aria-owns={open ? 'actionMenu' : undefined}
              aria-haspopup="true"
              onClick={this.handleMenuClick}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="actionMenu"
              anchorEl={anchorEl}
              open={open}
              onClose={this.handleMenuClose}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5
                }
              }}>
              {actions.map((action: any, idx: number) => {
                return (
                  <MenuItem key={idx} onClick={this.handleActionClick(action)}>
                    <span dangerouslySetInnerHTML={{__html: action.label}} />
                  </MenuItem>
                );
              })}
            </Menu>
          </div>
        );
      } else {
        if (reserveRowActionSpace) {
          actionArea = (
            <div
              className={
                classes.clickableMenu + ' ' + 'query-item-view-actions'
              }>
              <IconButton></IconButton>
            </div>
          );
        }
      }
    }

    let rowClass = classes.row;
    if (this.props.onRowClick) {
      rowClass = classes.clickableRow;
    }

    let selectorIcon: string = 'far fa-square ';
    let selectionClass: string = ' unselectedRow ';
    if (this.props.selected) {
      selectorIcon = 'far fa-check-square ';
      selectionClass = ' selectedRow ';
    }

    let selectionArea: any = null;
    if (onSelectionChange) {
      if (itemData["_SummaryActionPolicyMessages"]) {
          selectionArea = (
        <div className={classes.selectorArea}>
          <i
            className={selectorIcon + classes.selectorWithError}
            onClick={this.handleRowSelection}
          />
        </div>
      );
      } else {
      selectionArea = (
        <div className={classes.selectorArea}>
          <i
            className={selectorIcon + classes.selector}
            onClick={this.handleRowSelection}
          />
        </div>
      );
      }
    }
    return (
      <div
        className={
          'query-item-view ' +
          classes.container +
          ' ' +
          `${'query-item-view'}${index}`
        }>
        {selectionArea}
        <div
          onClick={this.handleRowClick}
          className={rowClass + selectionClass}>
          <DefinitionSection
            data={itemData}
            titleOverride={resultsTitleOverride}
            definition={resultItemDef}
            path={''}
            policyMessages={policyMessages}
            gridSpacing={gridSpacing}
            customRenderers={customRenderers}
            customMessages={customMessages}
            suppressTitle
          />
        </div>
        {actionArea}

        {
          // Putting this at the bottom of the sibling HTML nodes so that is naturally orders to the top, although, we can also use a z-index if necessary.
        }
      </div>
    );
  }
}

export default withStyles(styles)(QueryItemView);
